import * as types from './actionTypes';
import agreementApi from '../api/agreementApi';

export const getAgreementsSuccess = agreements => ({
  agreements,
  type: types.GET_AGREEMENTS_SUCCESS
});

export const getAgreements = () =>
  dispatch =>
    agreementApi.get().then((response) => {
      dispatch(getAgreementsSuccess(response.agreements));
    });



// WEBPACK FOOTER //
// ./src/actions/agreementActions.js